import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import Resume from '../components/Resume';
import Services from '../components/Services';
import Footer from '../components/Footer';
import { homeObjOne, homeObjThree } from '../components/InfoSection/Data';
import { homeObjTwo } from '../components/Resume/Data';

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return (
      <>
        <Sidebar isOpen = { isOpen } toggle = { toggle }/>
        <Navbar toggle = { toggle }/>
        <HeroSection />
        <InfoSection { ...homeObjOne }/>
        <Resume { ...homeObjTwo }/>
        <Services />
        <InfoSection { ...homeObjThree }/>
        <Footer />
      </>
  );
};

export default Home;
